import * as actionTypes from './actionTypes';
import axiosInstance from '../../axios-instance';

export const airportsStart = () => {
  return {
    type: actionTypes.AIRPORTS_START
  };
};

export const airportsSuccess = payload => {
  return {
    type: actionTypes.AIRPORTS_SUCCESS,
    payload: payload
  };
};

export const airportsFail = error => {
  return {
    type: actionTypes.AIRPORTS_FAIL,
    error: error
  };
};

export const airportsGetList = (region, state = null) => {
  return dispatch => {
    dispatch(airportsStart());
    axiosInstance()
      .get(
        `/airports.json?country=${region}` +
          (state !== null ? `&state=${state}` : '')
      )
      .then(response => {
        dispatch(airportsSuccess(response.data));
      })
      .catch(err => {
        dispatch(airportsFail(err.response.data.message));
      });
  };
};

export const airportsAutosuggestList = phraze => {
  return dispatch => {
    dispatch(airportsStart());
    axiosInstance()
      .get(
        `/airports.json?phraze=${phraze}`
      )
      .then(response => {
        dispatch(airportsSuccess(response.data));
      })
      .catch(err => {
        dispatch(airportsFail(err.response.data.message));
      });
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/airports.js